module.exports = __webpack_public_path__ + "img/logo_kakao.63249e00.jpg";